// @flow
import { darken } from 'polished';

export function createGeneratorBsButtonColors(
  contrastColor: (string) => string,
  borderAmountOfLight: number,
) {
  return function generateBsButtonColors(
    type: string,
    color: string,
    borderColor: string = darken(borderAmountOfLight, color),
  ) {
    return {
      [`btn${type}Color`]: contrastColor(color),
      [`btn${type}Bg`]: color,
      [`btn${type}Border`]: borderColor,
    };
  };
}

export default createGeneratorBsButtonColors;



// WEBPACK FOOTER //
// ./src/themes/mixins/createGeneratorBsButtonColors.js